import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import isValid from 'date-fns/isValid';
import parse from 'date-fns/parse';
import format from 'date-fns/format';

import { isRequired } from 'components/Questionnaires/validators';
import DateDropdown from 'components/Common/Inputs/DateDropdown';

export const QuestionDateDropdownField = ({ intl, blockId, question, className, onChange }) => {
  const getAnswer = (date) => {
    const parsed = parse(date, question.componentProps?.dateFormat ?? 'MM-dd-yyyy', new Date());
    return isValid(parsed) ? format(parsed, question.componentProps?.dateFormat) : '';
  };

  const [inputValue, setInputValue] = useState(getAnswer(question?.answer ?? question.default ?? ''));

  const onInputChange = (value) => {
    setInputValue(value);
    onChange(question, value);
    return true;
  };

  useEffect(() => {
    if (inputValue) {
      onChange(question, inputValue);
    }
  }, []);

  useEffect(() => {
    if (inputValue !== question.answer) {
      setInputValue(getAnswer(question.answer ?? ''));
    }
  }, [question.answer]);

  return (
    <DateDropdown
      key={ `${ blockId }-${ question.id }` }
      id={ `${ blockId }-${ question.id }` }
      name={ question.id }
      className={ `${ className }${ question.isValid === false ? ' error' : '' }` }
      minDate={ question.componentProps?.minDate ?? '' }
      maxDate={ question.componentProps?.maxDate ?? '' }
      dateFormat={ question.componentProps?.dateFormat ?? 'MM-dd-yyyy' }
      monthYearOnly={ question.componentProps?.monthYearOnly ?? false }
      showToolTip={ question.componentProps?.showToolTip ?? false }
      onChange={ (date) => { onInputChange(date); } }
      value={ inputValue }
      readOnly={ question.disabled }
      answerRequired={ isRequired(question) }
      describedBy={ question.isValid === false ? (`${ blockId }-${ question.id }-error`) : undefined }
    />
  );
};

QuestionDateDropdownField.displayName = 'QuestionDateDropdownField';

QuestionDateDropdownField.propTypes = {
  intl: PropTypes.shape().isRequired,
  blockId: PropTypes.string.isRequired,
  question: PropTypes.shape().isRequired,
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired
};

QuestionDateDropdownField.defaultProps = {
  className: '',
};

export default QuestionDateDropdownField;
